import { useCancelScale } from '@src/helper/hooks/use-cancle-scale';
import React, { FC } from 'react';

export const PdfViewContext = React.createContext(false);

interface PdfViewProviderProps {
  children: React.ReactNode;
}

export const PdfViewProvider: FC<PdfViewProviderProps> = ({ children }) => {
  useCancelScale();
  return <PdfViewContext.Provider value>{children}</PdfViewContext.Provider>;
};
